import React from "react";
import styles from "./CircularIconButton.module.css";
import { ReactComponent as EllipsisIcon } from "../../assets/icons/surroundingIcon.svg";

interface CircularIconButtonProps {
    onClick?: () => void;
    icon: React.ReactNode;
    className?: string;
    innerButtonClassName?: string;
}

const CircularIconButton: React.FC<CircularIconButtonProps> = ({
    onClick,
    icon,
    className = "",
    innerButtonClassName = "",
}) => {
    const buttonClass = `${styles.button} ${className}`;

    return (
        <div className={styles.container}>
            <button type="button" onClick={onClick} className={buttonClass}>
                <span className={styles.wrapper}>
                    <EllipsisIcon className={styles.ellipsisIcon} />
                    <span className={`${styles.innerIcon} ${innerButtonClassName}`}>{icon}</span>
                </span>
            </button>
        </div>
    );
};

export default CircularIconButton;
